import { Link } from 'react-scroll';

const Hero = () => {
    return (
        <section id="home" className="bg-gradient-to-r from-red-900 to-black text-white min-h-[80vh] flex items-center px-6 md:px-16 py-20">
            <div className="w-full flex flex-col md:flex-row items-start gap-12" data-aos="fade-up" data-aos-duration="1000">

                <div className="text-center mb-16 max-w-3xl mx-auto">
                    <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-4">
                        Professional <span className="text-red-500">Red Team</span> Services
                    </h1>
                    <p className="text-gray-300">
                        Comprehensive red teaming and vulnerability assessment & penetration testing services
                        for organizations of all sizes.
                    </p>
                    <div className="flex justify-center mt-6 gap-4">
                        <Link
                            to="contact"
                            smooth={true}
                            offset={-20}
                            duration={500}
                            className="border border-red-600 hover:bg-red-700 hover:text-white text-red-400 font-semibold px-5 py-2 rounded inline-block cursor-pointer"
                        >
                            Start Assesment
                        </Link>
                        <Link
                            to="services"
                            smooth={true}
                            offset={-20}
                            duration={500}
                            className="bg-red-600 hover:bg-red-700 text-white font-semibold px-5 py-2 rounded inline-block cursor-pointer"
                        >
                            Explore Services
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
